import React, { ErrorInfo } from 'react';

type MyProps = {};
type MyState = { hasError: boolean };

export class ErrorBoundaries extends React.Component<MyProps, MyState> {
  constructor(props: MyProps | Readonly<MyProps>) {
    super(props);
  }

  state = { hasError: false };

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div
          className="text-secondary d-flex flex-column align-items-center justify-content-center"
          style={{ height: '100vh' }}
        >
          <h1>Something went wrong.</h1>
          <p className="text-secondary">Try refreshing the page, or try again later</p>
        </div>
      );
    }

    // eslint-disable-next-line react/prop-types
    return this.props.children;
  }
}
